<template>
  <InsurancePlanFilterOutlined
    v-if="model.isUndefined"
    :insurance-plan="insurancePlan"
    :plans-url="plansUrl"
    :non-clearable="nonClearable"
    @insurance-changed="insuranceChanged"
  />
  <sp-alert
    v-else-if="!model.isSelfPay"
    class="insurance-alert"
    :class="breakpointModifierClass"
    :variant="variant"
    :type="model.type"
    compact
  >
    <CompactLayoutContent :model="model" :accepted-label="acceptedLabel" />
  </sp-alert>
</template>

<script setup>
import { computed } from "vue";
import { useBreakpoints } from "#ce/composables/useBreakpoints";
import CompactLayoutContent from "./CompactLayoutContent.ce.vue";
import InsurancePlanFilterOutlined from "./InsurancePlanFilterOutlined.ce.vue";
import { booleanAttribute } from "#ce/utils/props";

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
  insurancePlan: {
    type: String,
    default: undefined,
  },
  plansUrl: {
    type: String,
    default: undefined,
  },
  acceptedLabel: {
    type: String,
    default: "Accepts Your Insurance",
  },
  nonClearable: booleanAttribute(),
});

const variant = computed(() => (props.model.isUndefined.value ? "flat" : undefined));
const { ltModifiers } = useBreakpoints();

const breakpointModifierClass = computed(() => [...ltModifiers.value]);

const emit = defineEmits(["insurance-changed"]);

function insuranceChanged(value) {
  emit("insurance-changed", value);
}
</script>

<style lang="scss" scoped>
.insurance-alert {
  margin-bottom: 0;
  --alert-append-icon-size: 22px;
  --alert-append-icon-fill: var(--sp-sys-color-link);
  --alert-append-icon-cursor: pointer;
  --alert-prepend-icon-size: 26px;
  --alert-display: inline-grid;
  &.--lt-sm-screen {
    --alert-display: grid;
  }
}
</style>
